// If value has changed, set collection type to survey
// Need this if data has been prefilled to something else (like modeled)
// But user updates it manually

const COLLECTION_TYPE_SURVEY = 'survey';

/**
 * Sets the collection type to 'survey' when a survey field value is modified.
 * This ensures that manually edited answers are tracked as survey-sourced data.
 *
 * @param {HTMLElement | JQuery} el - The element (input, textarea, select, etc.)
 *   that triggered the change.
 */
export default function(el) {

    let hiddenCollectionTypeField = $(el).closest('.survey-card-body').find('.collection-type');

    if (hiddenCollectionTypeField.length !== 0) {
      hiddenCollectionTypeField.val(COLLECTION_TYPE_SURVEY);
    }

}